import type { UnitGroup } from "@/types";
export const sortUnitsByProperty = (
    units: UnitGroup[],
    property: 'vacancy' | 'price' | 'area',
    order: 'asc' | 'desc'
): UnitGroup[] => {
    return units.slice().sort((a, b) => {
        let valA = 0;
        let valB = 0;

        switch (property) {
            case 'vacancy':
                // Calculate vacancy as available units divided by total units
                valA = a.available ?? 0;
                valB = b.available ?? 0;
                break;

            case 'price':
                valA = a.rates
                    ? a.rates.display_rate ?? 0
                    : 0;
                valB = b.rates
                    ?  b.rates.display_rate ?? 0
                    : 0;
                break;

            case 'area':
                // Use the area of the representative unit
                valA = a.representative_unit
                    ? a.representative_unit.area
                    : 0;
                valB = b.representative_unit
                    ? b.representative_unit.area
                    : 0;
                break;

            default:
                // If property is not recognized, keep the original order
                return 0;
        }

        // Handle undefined or null values by treating them as zero
        valA = valA ?? 0;
        valB = valB ?? 0;

        // Sort in ascending order; for descending, reverse valA and valB
        if (order === 'asc') {
            return valA - valB;
        } else {
            return valB - valA;
        }
    });
};